import { render, staticRenderFns } from "./bookingagoraaktarim.vue?vue&type=template&id=43ca9c7c&"
import script from "./bookingagoraaktarim.vue?vue&type=script&lang=js&"
export * from "./bookingagoraaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports